import React, {useEffect} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";
import projectUtils from "../../../../../../utils/project-utils.js";

function TSpan({ children, className = "" }) {
  return (
    <span className={`mr-2 text-zinc-600 ${className}`}>
            {children}
        </span>
  )
}

const formatDate = (date) => {
  if(date === "Não informado" || date === "Atual") return date
  const [a,m,d] = date.split("-");
  return `${d}/${m}/${a}`
}

const AgentData = ({data, isLeader}) => {
  const reportName = isLeader ? "Dados do responsável" : "Dados do agente";

  useEffect(() => {
    const rows = Object.values(data);

    const rowsToExport = [
      ...rows.slice(0, 7),
      `${formatDate(rows[7])} - ${formatDate(rows[8], "DD/MM/YYYY")}`
    ];

    const fieldMap = {
      name: "Nome",
      namewar: "Nome de guerra",
      status: "Status",
      team: "Equipe",
      employee_code: "Nº Funcional",
      rank: "Patente",
      depto: "Departamento"
    };
    const labels = Object.keys(data).filter(el => el !== "admission" && el !== "termination").map(key => fieldMap[key] ?? key);
    labels.push("Período efetivo");
    ReportUtils.createExportableTable(labels, rowsToExport, reportName, null, ["Descrição", "Valor"]);
  }, [data, isLeader]);

  return(
    <>
      <div className="flex flex-col gap-4">
        <div className="report-divisor">
          <span className="divisor-title">{reportName.toUpperCase()}</span>
        </div>
        <table
          id="agent-data"
          className="table report-table !border-b-0"
          sheet-name={isLeader ? "Dados do responsável" : "Dados do agente"}
        >
          <tbody className="bg-white !border-b-0">
          <tr className="table-break-word !border-b-0">
            <td className="px-2! py-0! !border-b-0">
              <div className="flex flex-col">
                <div className="space-y-4 flex">
                  <div className="w-[66%]">
                    <TSpan>Nome completo:</TSpan>
                    <span className="font-bold">{data.name ?? ""}</span>
                  </div>
                  <div className="flex-1">
                    <TSpan>Status:</TSpan>
                    {data.status === "Inativo"
                      ? <span className="font-bold text-[#ed5565]">Inativo</span>
                      : <span className="font-bold text-[#219453]">Ativo</span>
                    }
                  </div>
                </div>
                <div className="flex justify-start">
                  <div className="space-y-4 w-[33%]">
                    <div>
                      <TSpan>Nome de guerra:</TSpan>
                      <span className="font-bold">{data.namewar ?? ""}</span>
                    </div>
                    <div>
                      <TSpan>Equipe:</TSpan>
                      <span className="font-bold">{data.team}</span>
                    </div>
                  </div>
                  <div className="space-y-4 w-[33%]">
                    <div>
                      <TSpan>Nº Funcional:</TSpan>
                      <span className="font-bold">{data.employee_code ?? ""}</span>
                    </div>
                    <div>
                      <TSpan>Depto:</TSpan>
                      <span className="font-bold">{data.depto ?? ""}</span>
                    </div>
                  </div>
                  <div className="space-y-4 flex-1">
                    <div>
                      <TSpan>Patente:</TSpan>
                      <span className="font-bold">{data.rank ?? ""}</span>
                    </div>
                    <div>
                      <TSpan>Período efetivo:</TSpan>
                      <span className="font-bold">{`${formatDate(data.admission)} - ${formatDate(data.termination)}` ?? ""}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div className="chart-divisor"></div>
    </>
  )
}

export default AgentData;